import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { NgClass } from '@angular/common';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { IconComponent } from '../../icon/icon.component';

export interface CardNavItem {
  href: string;
  icon: string;
  tooltip: string;
}

@Component({
  selector: 'app-card-shell',
  imports: [NgClass, NgbTooltip, IconComponent],
  templateUrl: './card-shell.component.html',
  styleUrl: './card-shell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class CardShellComponent {
  public readonly title = input.required<string>();
  public readonly online = input<boolean>(true);
  public readonly navItems = input<CardNavItem[]>([]);
}
